import React, { useState } from 'react';
import classNames from 'classnames';
import { useNavBarPath } from '@utils/nav-bar';
import PrimaryMenu from './components/primary-menu';
import './style/index.scss';

const App: React.FC = () => {
  const { isExpanded } = useNavBarPath();
  const [isSidebarhovered, setIsSidebarhovered] =
    React.useState<boolean>(false);
  const [isModelOpen, setIsModelOpen] = useState<boolean>(false);
  return (
    <div
      className='flex flex-wrap content-start relative text-unique-800 leading-1.2 basis-full w-full'
      onMouseOver={() => {
        if (window['stepReorderState']) return;
        setIsSidebarhovered(true);
      }}
      onMouseLeave={() => {
        if (!isModelOpen) setIsSidebarhovered(false);
      }}>
      <PrimaryMenu
        isPrimaryMenuExpanded={isExpanded || isSidebarhovered}
        isSidebarhovered={!isExpanded && isSidebarhovered}
        classNameValue={classNames(
          isExpanded
            ? 'w-full'
            : 'w-full border-r-[0.5px] border-secondary-200',
        )}
        setIsSidebarhovered={setIsSidebarhovered}
        setIsModelOpen={setIsModelOpen}
      />
    </div>
  );
};

export default App;
